import styled from "@emotion/styled";
import { Box, Input } from "src/components/UI";

export const Container = styled.div`
  position: relative;
`;

export const InputSelect = styled(Input)`
  &:focus-within ~ label,
  &:not(:placeholder-shown) ~ label {
    bottom: calc(100% - 28px);
    font-size: 0.625rem;
    font-weight: 700;
  }
`;

export const SelectionList = styled.div`
  display: block;
  position: absolute;
  top: 100%;
  z-index: 1;
  background: white;
  box-shadow: 0px 2px 12px 0px #7d7d7d40;
  width: 100%;
  border-radius: 8px;
  max-height: 328px;
  overflow-y: auto;
`;

export const SelectionItem = styled.div`
  padding: 8px 16px;
  border-bottom: 1px solid #f4f4f4;
  cursor: pointer;
`;

export const NoSelectionList = styled(Box)`
  padding: 8px 16px;
`;
